<template>
    <div
        ref="clickToCallSnackbar"
        class="click-to-call-snackbar tw-w-full tw-flex tw-justify-between tw-p-4 tw-bg-secondary-light tw-transition-transform tw-duration-[800ms] tw-ease-vdp-sticky"
        :class="{
            'tw-fixed tw-z-50 tw-bottom-6 tw-right-6 lg:tw-bottom-8 lg:tw-right-8 tw-max-w-[calc(100%-48px)] lg:tw-max-w-[679px] tw-items-center tw-shadow-md-down': !isLandingPage,
            'tw-flex-col lg:tw-flex-row tw-gap-4 tw-border-border-color tw-border-solid': isLandingPage,
            'lg:tw-items-center tw-rounded tw-border': isLandingPage && !customShape,
            'lg:tw-grid lg:tw-grid-cols-2 lg:tw-items-end lg:tw-p-6 max-lg:tw-rounded lg:tw-rounded-b-lg max-lg:tw-border lg:tw-border-t lg:tw-border-placeholder': customShape,
        }"
    >
        <div class="click-to-call-snackbar__content tw-flex tw-items-center tw-gap-2">
            <dk-button
                v-if="!isLandingPage"
                class="click-to-call-snackbar__close-button !tw-w-icon-xs !tw-h-icon-xs"
                variant="ghost"
                is-icon-only
                is-small
                @click="onClose"
            >
                <dk-icon name="ds-close-default" size="xs" />
            </dk-button>
            <p
                class="click-to-call-snackbar__cta tw-hidden lg:tw-block"
                :class="{
                    'tw-text-xs lg:tw-text-base tw-leading-2xs [&>span]:tw-font-bold': !isLandingPage,
                    'tw-text-base first-line:tw-font-semibold tw-leading-base !tw-block': isLandingPage,
                    'lg:tw-text-sm lg:tw-leading-xs': customShape,
                }"
                v-html="bannerCta"
            ></p>
            <p
                v-if="!isLandingPage"
                class="click-to-call-snackbar__cta tw-block lg:tw-hidden tw-text-xs tw-leading-2xs [&>span]:tw-font-bold"
                v-html="ctaWithLineBreak"
            ></p>
        </div>
        <dk-button
            class="click-to-call-snackbar__call-button tw-hidden lg:tw-flex tw-min-w-[164px] tw-justify-center tw-items-center tw-gap-1"
            :class="{
                'tw-w-full lg:tw-w-fit tw-min-w-[200px] !tw-flex': isLandingPage,
                'lg:!tw-w-8 lg:!tw-h-8 lg:tw-min-w-full lg:!tw-text-sm lg:!tw-leading-xs': customShape,
            }"
            @click="onClickToCall"
        >
            {{ $t('click-to-call.call-now-cta') }}
            <dk-icon
                class="!tw-hidden lg:!tw-block"
                name="ds-phone-filled"
                :size="isLandingPage && !customShape ? 's' : 'xs'"
            />
            <dk-icon class="!tw-block lg:!tw-hidden" name="ds-phone-filled" size="xs" />
        </dk-button>
        <dk-button
            v-if="!isLandingPage"
            class="click-to-call-snackbar__call-button-mobile tw-flex lg:tw-hidden tw-justify-center tw-items-center tw-gap-1"
            is-icon-only
            :is-small="true"
            @click="onClickToCall"
        >
            <dk-icon name="ds-phone-filled" size="xs" />
        </dk-button>
    </div>
</template>

<script>
export default {
    name: 'DkClickToCallSnackbar',
    components: {
        DkIcon: () => ({
            component: import(/* webpackChunkName: "DkIcon-vue" */ '@v4/common/components/atoms/DkIcon.vue'),
        }),
        DkButton: () => ({
            component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton.vue'),
        }),
    },
    props: {
        title: {
            type: String,
            default() {
                return this.$t('click-to-call.need-help');
            },
        },
        cta: {
            type: String,
            required: true,
        },
        phoneNumber: {
            type: String,
            required: true,
        },
        isLandingPage: {
            type: Boolean,
            default: false,
        },
        customShape: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ctaWithoutLineBreak() {
            return `${this.title} ${this.cta}`;
        },
        ctaWithLineBreak() {
            return `${this.title}<br>${this.cta}`;
        },
        bannerCta() {
            return this.isLandingPage ? this.ctaWithLineBreak : this.ctaWithoutLineBreak;
        },
    },
    mounted() {
        // Set the height of the click-to-call
        // in a CSS variable to use it to translate
        // the CTC banner when the Sticky CTAs show up
        // on the VDP Page.
        const $clickToCallSnackbar = this.$refs.clickToCallSnackbar;
        $clickToCallSnackbar.style.setProperty('--elem-height', `${$clickToCallSnackbar.offsetHeight}px`);
    },
    methods: {
        onClose() {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        },
        onClickToCall() {
            this.$emit('click-to-call');
        },
    },
};
</script>
